<template>
  <div class="animated fadeIn" id="list-faq">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Paramétrage des FAQ</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="items" :options="options">
          <div slot="type_rente" slot-scope="props" class="slot-rente-faq">{{ props.row.type_rente }}</div>
          <!-- <div slot="reponse" slot-scope="props" class="slot-reponse-faq">
              <div v-html="props.row.reponse"></div>
          </div> -->
          <div slot="action" slot-scope="props" class="slot-actions-faq">
            <b-button v-if="canAccess(rules.MANAGE_FAQ)" type="button" @click.prevent="destroy(props.row.id)" class="badge badge-danger mr-3 p-2"><i class="fa fa-remove"></i> Supprimer
            </b-button>
            <b-button v-if="canAccess(rules.MANAGE_FAQ)" type="button" @click="editAdminFaq('edit', props.row.id)" class="badge badge-primary mr-3 p-2">
              <i class="fa fa-edit"></i> Modifier
            </b-button>
            <b-button type="button" @click="editAdminFaq('show', props.row.id)" class="badge badge-success p-2">
              <i class="fa fa-eye"></i> Consulter
            </b-button>
          </div>
        </v-client-table>
      </b-card-body>
      <div slot="footer" v-if="canAccess(rules.MANAGE_FAQ)">
        <b-button type="button"  @click="editAdminFaq('add')" class="pull-right" size="md" variant="primary">
            <i class="fa fa-plus"></i> Ajouter une FAQ
        </b-button>
      </div>
    </b-card>
    <div>
      <b-modal ref="modal-faq" size="xl" title="Détails de la question / réponse">
        <div class="animated fadeIn">
          <b-row>
            <b-col md="12">
              <b-card>
                <div slot="header">
                  <strong><i class="fa fa-align-justify"></i> {{ question }}</strong>
                </div>
                <div class="card">
                  <b-form-group>
                    <a href="#" style="cursor:text" class="btn btn-primary">{{ selectedType }}</a>
                  </b-form-group>

                  <b-form-group>
                    <div style="padding:12px;" class="card-text" v-html="contentForEditor"></div>
                  </b-form-group>
                </div>
              </b-card>
            </b-col>
          </b-row>
        </div>
        <template v-slot:modal-footer>
          <div class="w-100">
            <b-button type="button" @click="cancel" size="md" class="pull-right" style="margin-right:10px">
              Fermer
            </b-button>
          </div>
        </template>
      </b-modal>
    </div>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from "../../utils/auth"
import {espaceBeneficiaireRules, hasRule} from '../../utils/rulesHelper'

export default {
  data() {
    return {
      question: "",
      contentForEditor: "",
      selectedType: "",
      rules: espaceBeneficiaireRules,
      columns: [
        "question",
        "type_rente",
        "action"
      ],
      items: [],
      options: {
        headings: {
          question: "Question",
          type_rente: "Type de rente",
          action: "Action"
        },
        sortable: ["question", "type_rente"],
        filterable: ["question", "type_rente"],
        perPage: 10,
        perPageValues: [10, 25, 50],
        texts: {
          filterPlaceholder: "Question, Type de rente"
        }
      }
    };
  },
  mounted() {
    this.all();
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
    canAccess(rule) {
      return hasRule(rule)
    },
    all() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/espaceBeneficiaire/adminfaq")
        .then(response => {
          this.$store.commit("IS_LOADING", false);
          this.items = response.data.adminFaq;
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
    destroy(id) {
        this.$swal.fire({
        title: 'Êtes-vous sûr?',
        text: "Voulez-vous vraiment supprimer cette FAQ ?",
        type: 'warning',
        showCancelButton: true,
        cancelButtonColor:"#ff1744",
        confirmButtonText: 'Annuler',
        cancelButtonText: 'Supprimer',
        }).then((result) => {
            if (!result.value) {
                this.$store.commit('IS_LOADING', true)
                this.$axios
                    .post("/espaceBeneficiaire/adminfaq/delete/"+id)
                    .then(response => {
                        this.$store.commit('IS_LOADING', false)
                        this.$swal({ position: 'top', type: 'success', title:'Suppression avec succès', text:'La faq a bien été supprimée',showConfirmButton: false, timer: 5000})
                        this.all()
                    })
                    .catch(function(error){
                        self.$store.commit('IS_LOADING', false)
                        self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',showConfirmButton: false, timer: 5000})
                    })
            }
        })
    },
    editAdminFaq(to,id) {
        if (to === 'edit') {
            this.$router.push({ path: '/espace-beneficiaire/gestion-des-faq/edit/' + id })
        } else if(to === "add") {
            this.$router.push({ path: '/espace-beneficiaire/gestion-des-faq/add' })
        } else if (to === "show") {
            //this.$router.push({ path: '/espace-beneficiaire/gestion-des-faq/show/' + id })
            this.populateFaq(id);
            this.faqId = id
            this.$refs['modal-faq'].show()
        }
    },
    populateFaq(id) {
      this.$store.commit("IS_LOADING", true);
      let faqId = id;
      let self = this;

      this.$axios
        .get("/espaceBeneficiaire/adminfaq/" + faqId)
        .then(response => {
          this.id = response.data.adminFaq.id;
          this.question = response.data.adminFaq.question;
          this.contentForEditor = response.data.adminFaq.reponse;
          if (response.data.adminFaq.type === 'QG') {
            this.selectedType = "Questions générales"
          } else if (response.data.adminFaq.type === 'INVAL') {
            this.selectedType = "Rente invalidité" 
          } else {
            this.selectedType = "Rente conjoint, éducation"
          }
          this.$store.commit('IS_LOADING', false)
        })
        .catch(function(error) {
          self.$store.commit('IS_LOADING', false)
          if(error.response && error.response.status === 404 && self != undefined){
            self.$router.push({ path: '/espace-beneficiaire/gestion-des-faq' })
            self.$swal({ position: 'top', type: 'warning', title:'Attention !!', text:'Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',showConfirmButton: false, timer: 5000})
          }
        });
    },
    cancel() {
      this.$refs['modal-faq'].hide()
    },
    returnBack() {
      this.$router.push({ path: '/espace-beneficiaire/gestion-des-faq' })
    },
  }
};
</script>

<style>
#list-faq .VueTables__table thead tr th:first-child {
  width: 60%;
}
#list-faq .VueTables__table thead tr th:nth-child(2) {
  width: 20%;
}
#list-faq .VueTables__table thead tr th:nth-child(3) {
  width: 20%;
}

</style>